module.exports = __webpack_public_path__ + "img/przedszkole2.2c441330.jpg";